import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * `cn` — merge de clases Tailwind con precedencia correcta.
 * Uso estándar en todos los componentes.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/** Formato de precio MXN con tax-inclusive (convención MX). */
export function formatPriceMxn(cents: number): string {
  return new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    maximumFractionDigits: 0,
  }).format(cents / 100);
}

/** Formato de precio USD (referencia). */
export function formatPriceUsd(cents: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(cents / 100);
}

/** ISO week number (lunes inicio, zona America/Mexico_City) — tarot. */
export function isoWeekMexico(date: Date): { year: number; week: number } {
  const mxDate = new Date(
    date.toLocaleString('en-US', { timeZone: 'America/Mexico_City' })
  );
  const d = new Date(Date.UTC(mxDate.getFullYear(), mxDate.getMonth(), mxDate.getDate()));
  const dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  const week = Math.ceil(((d.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);
  return { year: d.getUTCFullYear(), week };
}

/** Slug desde string (no diacríticos). */
export function slugify(input: string): string {
  return input
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
